import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding-left: 8px;
`;
